module.exports = __webpack_public_path__ + "static/media/boomstam-1.48efe12f.jpeg";